import { render } from "./OrgUnitEditModal.vue?vue&type=template&id=e710d492"
import script from "./OrgUnitEditModal.vue?vue&type=script&lang=js"
export * from "./OrgUnitEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__